module.exports = [{"type":"hash","text":"Unsubscribe"},{"type":"normal","text":"The format of unsubscription is as follows:"},{"type":"code","text":"{ \"id\": \"id1\", \"reqType\": \"unsub\", \"dataType\": \"data to unsub\"}"},{"type":"normal","text":"Confirmation of Unsubscription:"},{"type":"code","text":"{ \"id\": \"id1\", \"code\": 0, \"msg\": \"\" }"},{"type":"html","text":"<h3>Symbol Description</h3>"},{"type":"warning","text":"Symbol must be fully capitalized"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/introduce/05_cancel_subscribe.json
// module id = hlb8
// module chunks = 3